import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'


const _hoisted_1 = { class: "px-5 pt-3 tasks-page-fill" }
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "tasks-table-section" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Task Template")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["ml-3 flex", _ctx.tableRow.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.tableRow.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[1] || (_cache[1] = _createTextVNode(" Filters ", -1))
        ], 2)
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-3" }, [
      _createElementVNode("p", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}